// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3802":"3b0b5777","6336":"fa10994f","9628":"ffe73276"}[chunkId] + ".chunk.css";
};